export const PACKAGE_NAME = 'jiraIssueTableGroupByDropdown';
export const TEAM_NAME = 'jira-yurree';
